import { render, staticRenderFns } from "./evalList.vue?vue&type=template&id=2b538a7c"
import script from "./evalList.vue?vue&type=script&lang=js"
export * from "./evalList.vue?vue&type=script&lang=js"
import style0 from "./evalList.vue?vue&type=style&index=0&id=2b538a7c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b538a7c')) {
      api.createRecord('2b538a7c', component.options)
    } else {
      api.reload('2b538a7c', component.options)
    }
    module.hot.accept("./evalList.vue?vue&type=template&id=2b538a7c", function () {
      api.rerender('2b538a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/experts/evalList.vue"
export default component.exports